/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

editCardModalStyles.container = {
    gap: 40,
};

editCardModalStyles.leftColumn = {
    width: 12,
    css: css`
        position: relative;
        &:after {
            content: " ";
            border-bottom: 1px solid ${getColor("common.ui12")};
            position: absolute;
            bottom: 0;
            right: 20px;
            left: 20px;
        }
    `,
};

editCardModalStyles.rightColumn = {
    width: 12,
};

editCardModalStyles.cardInfoContainer = {
    gap: 15,
};

editCardModalStyles.makeDefaultCardGridItem = {
    width: 12,
    css: css`
        > div {
            margin-bottom: 15px;
        }
    `,
};

editCardModalStyles.cardNicknameGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        ${screen("gte", "md")} {
            > div {
                margin-right: 10px;
            }
        }
    `,
};

editCardModalStyles.cardNumberGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        ${screen("gte", "md")} {
            > div {
                margin-left: 10px;
            }
        }
    `,
};

editCardModalStyles.paymetricDetailsStyles = {
    paymetricGridItem: editCardModalStyles.cardNumberGridItem,
};

editCardModalStyles.nameOnCardGridItem = editCardModalStyles.cardNicknameGridItem;

editCardModalStyles.expirationMonthGridItem = {
    width: [12, 6, 3, 3, 3],
    css: css`
        > div {
            ${screen("gte", "md")} {
                margin-right: 8px;
                margin-left: 10px;
            }
            ${screen("lt", "md")} {
                margin-right: 13px;
                margin-left: 0;
            }
            ${screen("lt", "sm")} {
                margin-right: 0;
            }
        }
    `,
};

editCardModalStyles.expirationYearGridItem = {
    width: [12, 6, 3, 3, 3],
    css: css`
        > div {
            margin-top: 24px;
            ${screen("gte", "md")} {
                margin-left: 18px;
            }
            ${screen("lt", "md")} {
                margin-left: 13px;
            }
            ${screen("lt", "sm")} {
                margin-left: 0;
                margin-top: 0;
            }
        }
    `,
};

editCardModalStyles.addressContainer = {
    gap: 15,
};

editCardModalStyles.useBillToAddressGridItem = editCardModalStyles.makeDefaultCardGridItem;

editCardModalStyles.address1TextFieldGridItem = editCardModalStyles.cardNicknameGridItem;

editCardModalStyles.address2TextFieldGridItem = editCardModalStyles.cardNumberGridItem;

editCardModalStyles.address3TextFieldGridItem = editCardModalStyles.cardNicknameGridItem;

editCardModalStyles.address4TextFieldGridItem = editCardModalStyles.cardNumberGridItem;

editCardModalStyles.countryGridItem = {
    width: editCardModalStyles.expirationMonthGridItem.width,
    css: css`
        &.full-width {
            flex-basis: 50%;
            max-width: 50%;

            > div {
                margin-right: 0;
            }
        }
        > div {
            ${screen("gte", "md")} {
                margin-right: 18px;
            }
            ${screen("lt", "md")} {
                margin-right: 13px;
            }
            ${screen("lt", "sm")} {
                margin-right: 0;
            }
        }
    `,
};

editCardModalStyles.stateGridItem = {
    width: [12, 6, 3, 3, 3],
    css: css`
        > div {
            ${screen("gte", "md")} {
                margin-left: 8px;
                margin-right: 10px;
            }
            ${screen("lt", "md")} {
                margin-left: 13px;
            }
            ${screen("lt", "sm")} {
                margin-left: 0;
            }
        }
    `,
};

editCardModalStyles.cityGridItem = editCardModalStyles.expirationMonthGridItem;

editCardModalStyles.postalCodeGridItem = {
    width: editCardModalStyles.expirationYearGridItem.width,
    css: css`
        > div {
            ${screen("gte", "md")} {
                margin-left: 18px;
            }
            ${screen("lt", "md")} {
                margin-left: 13px;
            }
            ${screen("lt", "sm")} {
                margin-left: 0;
            }
        }
    `,
};

editCardModalStyles.bottomGridItem = {
    width: 12,
    css: css`
        && .modal-actions {
            margin-top: 10px;
        }
    `,
};
